import React, {Component} from 'react';
import {connect} from 'react-redux';
import {getSessionProfile} from '../../../gateways/session';
import {putProfile, putProperty} from '../../../gateways/session';
import {USA_STATES, SOUTHERN_CALIFORNIA_PROPERTY_ZONES, SURVEY_TYPES} from '../../../constants';
import {PropertyList} from '../../../components/PropertyList'
import {
  Row,
  Col,
  Button,
  FormFeedback,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  InputGroup,
  Alert
} from 'reactstrap';

class Profile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      "action": "",
      "renderProfileForm": false,
      "renderPropertyForm": false,
      "formProfile": {
        "firstName": "",
        "lastName": "",
        "isEmailResult": false,
        "isHardCopyResult": false,
        "joinSurveys": false
      },
      isListUpdated: false,
      isEdit: false,
      formProperty: {
        propertyName: '',
        propertyAddress: '',
        city: '',
        state: '',
        surveyType: '',
        zipCode: '',
        phoneNumber: '',
        faxNumber: '',
        contactName: '',
        contactTitle: '',
        contactEmail: '',
        generalManagerName: '',
        numberOfRooms: '',
        luxury: false,
        union: false,
        inn: false,
        golf: false,
        limited: false,
        zone: '1'
      },
      formPropertyError: {
        propertyName: '',
        propertyAddress: '',
        city: '',
        state: '',
        surveyType: '',
        zipCode: '',
        phoneNumber: '',
        faxNumber: '',
        contactName: '',
        contactTitle: '',
        contactEmail: '',
        generalManagerName: '',
        numberOfRooms: '',
        luxury: '',
        union: '',
        inn: '',
        golf: '',
        limited: '',
        zone: '',
      },
      "formProfileError": {
        "firstName": "",
        "lastName": "",
        "isEmailResult": "",
        "isHardCopyResult": "",
        "joinSurveys": ""
      },
      profileAlert: {
        message: "",
        color: ""
      },
      propertyAlert: {
        message: "",
        color: ""
      },
      surveyTypes: [],
      zones: [],
      showLuxury: true,
      showUnion: true,
      showInn: true,
      showGolf: true,
      showLimited: true
    };

    this.onEditPropertyClick = this.onEditPropertyClick.bind(this);
    this.onCreatePropertyClick = this.onCreatePropertyClick.bind(this);
    this.changePropertiesState = this.changePropertiesState.bind(this);
  }

  componentWillMount() {
    getSessionProfile().then((result) => {
      if ( !result.error ) {
        let state = {
          "formProfile": {},
          "formProperty": {}
        };
        if ( result.user != null ) {
          // state.formProfile = {
          //   id: result.user.id,
          //   "firstName": result.user.firstname,
          //   "lastName": result.user.lastname,
          //   "email": result.user.email,
          //   "isEmailResult": result.user.isEmailResult,
          //   "isHardCopyResult": result.user.isHardCopyResult,
          //   "joinSurveys": result.user.joinSurveys
          // }
          state.formProfile = result.user;
        }
        // if ( result.properties != null ) {
        //   state.formProperty = result.properties[0];
        //   state.listProperty = result.properties;
        //   // state.formProperty = {
        //   //   id: result.property.id,
        //   //   propertyName: result.property.propertyName,
        //   //   propertyAddress: result.property.propertyAddress,
        //   //   city: result.property.city,
        //   //   state: result.property.state,
        //   //   surveyType: result.property.surveyType,
        //   //   zipCode: result.property.zipCode,
        //   //   phoneNumber: result.property.phoneNumber,
        //   //   faxNumber: result.property.faxNumber,
        //   //   contactName: result.property.contactName,
        //   //   contactTitle: result.property.contactTitle,
        //   //   contactEmail: result.property.contactEmail,
        //   //   generalManagerName: result.property.generalManagerName,
        //   //   numberOfRooms: result.property.numberOfRooms,
        //   //   luxury: result.property.luxury,
        //   //   union: result.property.union,
        //   //   inn: result.property.inn,
        //   //   golf: result.property.golf,
        //   //   limited: result.property.limited,
        //   //   zone: result.property.zone
        //   // }
        // }
        this.setState({
          "renderProfileForm": result.user !== null,
          "renderPropertyForm": result.user.joinSurveys,
          "formProperty": {
            ...this.state.formProperty,
            ...state.formProperty
          },
          "formProfile":{
            ...this.state.formProfile,
            ...state.formProfile
          }
        }, () => {
          // if ( result.property ) {
          //   this.generateSurveyTypes(result.property.state);
          // }
        });
      }
    });
  }

  generateSurveyTypes(state) {
    let surveyTypes = SURVEY_TYPES.filter((surveyType) => {
      return surveyType.state === 'ALL' || surveyType.state === state;
    });
    this.setState({
      surveyTypes: surveyTypes,
      "formProperty": {
        ...this.state.formProperty
      }
    }, () => {
      this.onChangeSurveyType(this.state.formProperty.surveyType);
    });
  }

  onChangeState(value) {
    this.setFormPropertyValue("state", value)
    .then(() => {
      this.setState({
        "formProperty": {
          ...this.state.formProperty
        }
      }, () => {
        this.generateSurveyTypes(value);
      });
    });
  }

  onChangeSurveyType(value) {
    let surveyType = SURVEY_TYPES.find((item) => {
      return value === item.key;
    });
    if ( surveyType ) {
      this.setFormPropertyValue("surveyType", value)
      .then(() => {
        this.setState({
          showLuxury: surveyType.has_luxury,
          showUnion: surveyType.has_union,
          showInn: surveyType.has_inn,
          showGolf: surveyType.has_golf,
          showLimited: surveyType.has_limited,
          zones: surveyType.zones,
          formProperty: {
            ...this.state.formProperty,
            luxury: surveyType.has_luxury ? this.state.formProperty.luxury : false,
            union: surveyType.has_union ? this.state.formProperty.union : false,
            inn: surveyType.has_inn ? this.state.formProperty.inn : false,
            golf: surveyType.has_golf ? this.state.formProperty.golf : false,
            limited: surveyType.has_limited ? this.state.formProperty.limited : false
          }
        });
      });
    } else {
      this.setState({
        showLuxury: true,
        showUnion: true,
        showInn: true,
        showGolf: true,
        showLimited: true,
        zones: [],
        formProperty: {
          ...this.state.formProperty,
          surveyType: '',
          luxury: false,
          union: false,
          inn: false,
          golf: false,
          limited: false
        }
      });
    }
  }

  get initialPropertyForm() {
    const formProperty = {
      propertyName: '',
      propertyAddress: '',
      city: '',
      state: '',
      surveyType: '',
      zipCode: '',
      phoneNumber: '',
      faxNumber: '',
      contactName: '',
      contactTitle: '',
      contactEmail: '',
      generalManagerName: '',
      numberOfRooms: '',
      luxury: false,
      union: false,
      inn: false,
      golf: false,
      limited: false,
      zone: '1'
    };
    return formProperty;
  }

  onCreatePropertyClick(e) {
    e.preventDefault();
    this.setState({
      formProperty: this.initialPropertyForm,
      isListUpdated: false,
      isEdit: false,
      surveyTypes: [],
      zones: [],
      showLuxury: true,
      showUnion: true,
      showInn: true,
      showGolf: true,
      showLimited: true
    });
    this.onPropertyAlertDismiss();
  }

  onEditPropertyClick(e, property) {
    e.preventDefault();
    console.log("property =", property);
    this.onPropertyAlertDismiss();

    if ( property ) {
      this.generateSurveyTypes(property.state);
    }

    this.setState({ isEdit: true, formProperty: property });
  }

  updateProfile() {
    if ( this.validateProfileInputs() ) {
      putProfile({
        ...this.state.formProfile
      }).then((result) => {
        let renderPropertyForm = this.state.formProfile.joinSurveys;
        if ( !result.error ) {
          this.setState({
            'profileAlert': {
              "message": "Your profile has been updated.",
              "color": "success"
            },
            "renderPropertyForm": renderPropertyForm
          });
        } else {
          if ( typeof result.msg !== 'undefined' ) {
          if ( Array.isArray(result.msg) ) {
            msg = result.msg.map(m => m.msg).join(" ");
          } else if (typeof result.msg === 'string') {
            msg = result.msg;
          } else {
            msg = "Something went wrong. Please contact administrator.";
          }
          this.setState({
            'profileAlert': {
              "message": msg,
              "color": "danger"
            },
            "renderPropertyForm": renderProfileForm
          });
          } else {
            this.setState({
              'profileAlert': {
                "message": "Something went wrong. Please contact administrator.",
                "color": "danger"
              },
              "renderPropertyForm": renderPropertyForm
            });
          }
        }
      }).catch((error) => {
        let message = "";
        if ( error.response && error.response.data ) {
          message = error.response.data.message;
        } else {
          message = error.message;
        }
        this.setState({ 'alert': {
          "message": message,
          "color": 'danger'
        }});
      });
    }
  }

  updateProperty() {
    if ( this.validatePropertyInputs() ) {
      putProperty({
        ...this.state.formProperty
      }).then((result) => {
        if ( !result.error ) {
          const updatedProperty = JSON.parse(JSON.stringify(this.state.formProperty));
          if (result.data) {
            updatedProperty.id = result.data.hotelId;
          }
          this.setState({
            'propertyAlert': {
              "message": "Property information has been updated.",
              "color": "success"
            },
            isListUpdated: true,
            isEdit: true,
            formProperty: updatedProperty
          });
        } else {
          if ( typeof result.msg !== 'undefined' ) {
            if ( Array.isArray(result.msg) ) {
              msg = result.msg.map(m => m.msg).join(" ");
            } else if (typeof result.msg === 'string') {
              msg = result.msg;
            } else {
              msg = "Something went wrong. Please contact administrator.";
            }
            this.setState({ 'propertyAlert': {
              "message": msg,
              "color": "danger"
            }});
          } else {
            this.setState({ 'propertyAlert': {
              "message": "Something went wrong. Please contact administrator.",
              "color": "danger"
            }});
          }
        }
      }).catch((error) => {
        let message = "";
        if ( error.response && error.response.data ) {
          message = error.response.data.message;
        } else {
          message = error.message;
        }
        this.setState({ 'alert': {
          "message": message,
          "color": 'danger'
        }});
      });
    }
  }

  validateInput(field, value ) {
    const fieldValidations = this.getFieldValidations();
    let result = this.validateMultipleRules(fieldValidations[field], value);
    return result;
  }

  setFormProfileError(field, message) {
    return new Promise((resolve, reject) => {
      this.setState({
        "formProfileError": {
          ...this.state.formProfileError,
          [field]: message
        }
      }, () => { resolve(); });
    });
  }

  setFormPropertyError(field, message) {
    return new Promise((resolve, reject) => {
      this.setState({
        "formPropertyError": {
          ...this.state.formPropertyError,
          [field]: message
        }
      }, () => { resolve(); });
    });
  }

  validatePropertyInputs() {
    let pass = true;
    let errors = {};

    const fieldValidations = this.getFieldValidations();

    Object.keys(this.state.formProperty).map((key) => {
      let validations = fieldValidations[key];
      if ( key === 'surveyType' ) {
        validations = this.state.surveyTypes.length > 0 ? validations : [];
      }
      let result = this.validateMultipleRules(validations, this.state.formProperty[key]);
      if ( !result.pass ) {
        pass = false;
        errors[key] = result.messages.join(' ');
      } else {
        errors[key] = "";
      }
    });

    if ( !pass ) {
      this.setState({
        "formPropertyError": {
          ...this.state.formPropertyError,
          ...errors
        }
      });
    }

    return pass;
  }

  validateProfileInputs() {
    let pass = true;
    let errors = {};

    const fieldValidations = this.getFieldValidations();

    Object.keys(this.state.formProfile).map((key) => {
      let result = this.validateMultipleRules(fieldValidations[key], this.state.formProfile[key]);
      if ( !result.pass ) {
        pass = false;
        errors[key] = result.messages.join(' ');
      } else {
        errors[key] = "";
      }
    });

    if ( !pass ) {
      this.setState({
        "formPropertyError": {
          ...this.state.formPropertyError,
          ...errors
        }
      });
    }

    return pass;
  }

  validateMultipleRules(rules, value) {
    let pass = true;
    let messages = [];
    if ( !Array.isArray(rules) ) {
      rules = [rules];
    }
    for (var i = 0; i < rules.length; i++) {
      let result = this.validate(rules[i], value);

      if ( !result.pass ) {
        pass = false;
        messages.push(result.message);
      }

    }
    return { pass: pass, messages: messages };
  }

  validate(rule, value) {
    let type = rule;
    let pass = true;
    let message = "";
    if ( typeof rule === "object" ) {
      type = rule.type;
    }
    switch (type) {
      case "email":
        pass = value !== '' ? /(.+)@(.+){2,}\.(.+){2,}/.test(value) : true;
        if ( !pass ) {
          message = "Invalid email address.";
        }
        break;
      case "max":
        pass = value.length <= rule.value;
        if ( !pass ) {
          message = "Value must not longer then " + rule.value + " character(s).";
        }
        break;
      case "confirmPassword":
        pass = value === this.state.formProfile.password;
        if ( !pass ) {
          message = "Password and Confirm password don't match."
        }
        break;
      case "required":
        pass = value !== '' && value !== null;
        if ( !pass ) {
          message = "This field is required.";
        }
        break;
      case "number":
        pass = !isNaN(value);
        if ( !pass ) {
          message = "Must be a number";
        }
        break;
      default:
        break;
    }
    return { pass: pass, message: message };
  }

  getFieldValidations() {
    return {
      "firstName": ["required", { "type": "max", "value": 255 }],
      "lastName": ["required", { "type": "max", "value": 255 }],
      "propertyName": ["required", { "type": "max", "value": 255 }],
      "propertyAddress": ["required", { "type": "max", "value": 255 }],
      "city": ["required", { "type": "max", "value": 50 }],
      "state": ["required", { "type": "max", "value": 50 }],
      "surveyType": ["required"],
      "zipCode": ["required", { "type": "max", "value": 50 }],
      "phoneNumber": ["required", { "type": "max", "value": 50 }],
      "faxNumber": [{ "type": "max", "value": 50 }],
      "contactName": ["required",{ "type": "max", "value": 255 }],
      "contactTitle": ["required",{ "type": "max", "value": 255 }],
      "contactEmail": ["required","email"],
      "generalManagerName": ["required", { "type": "max", "value": 255 }],
      "numberOfRooms": ["required", "number"],
      "luxury": ["required"],
      "union": ["required"],
      "inn": ["required"],
      "golf": ["required"],
      "limited": ["required"],
      "zone": ["required"]
    };
  }

  renderSurveyTypes() {
    if ( this.state.surveyTypes.length > 0 ) {
      return (
        <FormGroup row>
          <Col md="3">
            <Label>Survey Type</Label>
          </Col>
          <Col xs="12" md="9">
            <Input
              type="select"
              name="survey_type"
              value={this.state.formProperty.surveyType}
              placeholder="Survey Type"
              valid={this.state.formPropertyError.surveyType ? false: null}
              invalid={this.state.formPropertyError.surveyType ? true: null}
              onChange={(e) => { this.onChangeSurveyType(e.target.value) }}>
              <option value="">Please select</option>
              {this.state.surveyTypes.map( (type, index) => {
                return (
                  <option key={type.key} value={type.key}>{type.name}</option>
                )
              } )}
            </Input>
            <FormFeedback>{this.state.formPropertyError.surveyType}</FormFeedback>
          </Col>
        </FormGroup>
      );
    }
  }

  onAlertDismiss() {
    this.setState({
      alert: {
        message: "",
        color: ""
      }
    });
  }

  setFormProfileValue(field, value) {
    return new Promise((resolve, reject) => {
      this.setState({
        "formProfile": {
          ...this.state.formProfile,
          [field]: value
        }
      }, () => {
        if ( this.state.formProfileError[field] !== '' ) {
          let result = this.validateInput(field, this.state.formProfile[field]);
          let msg = "";
          if ( !result.pass ) {
            msg = result.messages.join(' ');
          }
          this.setFormProfileError(field, msg)
          .then(() => {
            resolve();
          });
        } else {
          resolve();
        }
      });
    });
  }

  setFormPropertyValue(field, value) {
    return new Promise((resolve, reject) => {
      this.setState({
        "formProperty": {
          ...this.state.formProperty,
          [field]: value
        }
      }, () => {
        if ( this.state.formPropertyError[field] !== '' ) {
          let result = this.validateInput(field, this.state.formProperty[field]);
          let msg = ""
          if ( !result.pass ) {
            msg = result.messages.join(' ');
          }
          this.setFormPropertyError(field, '')
          .then(() => {
            resolve();
          });
        } else {
          resolve();
        }
      });
    });
  }

  renderLuxuryPropertyField() {
    if ( this.state.showLuxury ) {
      return (
        <FormGroup row>
          <Col md="3">
            <Label>Luxury Property</Label>
          </Col>
          <Col xs="12" md="9">
            <FormGroup check inline>
              <div className="radio">
                <Label check>
                  <Input type="radio" name="luxury" value="yes"
                    checked={this.state.formProperty.luxury}
                    valid={this.state.formPropertyError.luxury ? false: null}
                    invalid={this.state.formPropertyError.luxury ? true : null}
                    onChange={(e) => { this.setFormPropertyValue("luxury", true) }}/>
                  Yes
                </Label>
              </div>
            </FormGroup>
            <FormGroup check inline>
              <div className="radio">
                <Label check>
                  <Input type="radio" name="luxury" value="no"
                    checked={!this.state.formProperty.luxury}
                    valid={this.state.formPropertyError.luxury ? false: null}
                    invalid={this.state.formPropertyError.luxury ? true : null}
                    onChange={(e) => { this.setFormPropertyValue("luxury", false) }}/>
                  No
                </Label>
              </div>
            </FormGroup>
          </Col>
        </FormGroup>
      );
    }
  }

  renderUnionPropertyField() {
    if ( this.state.showUnion ) {
      return (
        <FormGroup row>
          <Col md="3">
            <Label>Union Property</Label>
          </Col>
          <Col xs="12" md="9">
            <FormGroup check inline>
              <div className="radio">
                <Label check>
                  <Input type="radio" name="union" value="yes"
                    checked={this.state.formProperty.union}
                    valid={this.state.formPropertyError.union ? false: null}
                    onChange={(e) => { this.setFormPropertyValue("union", true) }}/>
                  Yes
                </Label>
              </div>
            </FormGroup>
            <FormGroup check inline>
              <div className="radio">
                <Label check>
                  <Input type="radio" name="union" value="no"
                    checked={!this.state.formProperty.union}
                    valid={this.state.formPropertyError.union ? false: null}
                    invalid={this.state.formPropertyError.union ? true: null}
                    onChange={(e) => { this.setFormPropertyValue("union", false) }}/>
                  No
                </Label>
              </div>
            </FormGroup>
          </Col>
        </FormGroup>
      );
    }
  }

  renderInnPropertyField() {
    if ( this.state.showInn ) {
      return (
        <FormGroup row>
          <Col md="3">
            <Label>Inn &/or Mid-Range Service Property</Label>
          </Col>
          <Col xs="12" md="9">
            <FormGroup check inline>
              <div className="radio">
                <Label check>
                  <Input type="radio" name="inn" value="yes"
                    checked={this.state.formProperty.inn}
                    valid={this.state.formPropertyError.inn ? false: null}
                    onChange={(e) => { this.setFormPropertyValue("inn", true) }}/>
                  Yes
                </Label>
              </div>
            </FormGroup>
            <FormGroup check inline>
              <div className="radio">
                <Label check>
                  <Input type="radio" name="inn" value="no"
                    checked={!this.state.formProperty.inn}
                    valid={this.state.formPropertyError.inn ? false: null}
                    invalid={this.state.formPropertyError.inn ? true: null}
                    onChange={(e) => { this.setFormPropertyValue("inn", false) }}/>
                  No
                </Label>
              </div>
            </FormGroup>
          </Col>
        </FormGroup>
      );
    }
  }

  renderGolfPropertyField() {
    if ( this.state.showGolf ) {
      return (
        <FormGroup row>
          <Col md="3">
            <Label>Golf-Related Positions Only Property</Label>
          </Col>
          <Col xs="12" md="9">
            <FormGroup check inline>
              <div className="radio">
                <Label check>
                  <Input type="radio" name="golf" value="yes"
                    checked={this.state.formProperty.golf}
                    valid={this.state.formPropertyError.golf ? false: null}
                    onChange={(e) => { this.setFormPropertyValue("golf", true) }}/>
                  Yes
                </Label>
              </div>
            </FormGroup>
            <FormGroup check inline>
              <div className="radio">
                <Label check>
                  <Input type="radio" name="golf" value="no"
                    checked={!this.state.formProperty.golf}
                    valid={this.state.formPropertyError.golf ? false: null}
                    invalid={this.state.formPropertyError.golf ? true: null}
                    onChange={(e) => { this.setFormPropertyValue("golf", false) }}/>
                  No
                </Label>
              </div>
            </FormGroup>
          </Col>
        </FormGroup>
      );
    }
  }

  renderLimitedPropertyField() {
    if ( this.state.showLimited ) {
      return (
        <FormGroup row>
          <Col md="3">
            <Label>Limited Service Property</Label>
          </Col>
          <Col xs="12" md="9">
            <FormGroup check inline>
              <div className="radio">
                <Label check>
                  <Input type="radio" name="limited" value="yes"
                    checked={this.state.formProperty.limited}
                    valid={this.state.formPropertyError.limited ? false: null}
                    onChange={(e) => { this.setFormPropertyValue("limited", true) }}/>
                  Yes
                </Label>
              </div>
            </FormGroup>
            <FormGroup check inline>
              <div className="radio">
                <Label check>
                  <Input type="radio" name="limited" value="no"
                    checked={!this.state.formProperty.limited}
                    valid={this.state.formPropertyError.limited ? false: null}
                    invalid={this.state.formPropertyError.limited ? true: null}
                    onChange={(e) => { this.setFormPropertyValue("limited", false) }}/>
                  No (Full Service)
                </Label>
              </div>
            </FormGroup>
          </Col>
        </FormGroup>
      );
    }
  }

  renderZoneField() {
    if ( this.state.zones.length > 0 ) {
      return (
        <FormGroup row>
          <Col md="3">
            <Label>Zone</Label>
          </Col>
          <Col xs="12" md="9">
            <FormGroup check>
              {this.state.zones.map( (zone, index) => {
                return (
                  <div key={zone.key} className="radio">
                    <Label check htmlFor={"zone" + zone.key}>
                      <Input type="radio" id={"zone" + zone.key} name="zone" value={zone.key}
                        checked={this.state.formProperty.zone === zone.key ? true : false}
                        valid={this.state.formPropertyError.zone ? false: null}
                        invalid={this.state.formPropertyError.zone ? true: null}
                        onChange={(e) => { this.setFormPropertyValue("zone", e.target.value) }}/>
                      {zone.name}
                    </Label>
                  </div>
                );
              })}
            </FormGroup>
          </Col>
        </FormGroup>
      );
    }
  }

  renderPropertyForm() {
    if ( this.state.renderPropertyForm ) {
      return (
        <Col xs="12" md="6">
          <Card>
            <CardHeader>
              <strong>Property</strong>
            </CardHeader>
            <CardBody>
              <Alert color={this.state.propertyAlert.color} isOpen={this.state.propertyAlert.message != ""} toggle={() => this.onPropertyAlertDismiss()}>
                {this.state.propertyAlert.message}
              </Alert>
              <Form className="form-horizontal">
                <div className="animated fadeIn">
                  <FormGroup row>
                    <Col md="3">
                      <Label>Property name</Label>
                    </Col>
                    <Col xs="12" md="9">
                      <Input
                        type="text"
                        name="property_name"
                        value={this.state.formProperty.propertyName}
                        placeholder="Property name"
                        valid={this.state.formPropertyError.propertyName ? false: null}
                        invalid={this.state.formPropertyError.propertyName ? true: null}
                        onChange={(e) => { this.setFormPropertyValue("propertyName", e.target.value) }}/>
                      <FormFeedback>{this.state.formPropertyError.propertyName}</FormFeedback>
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Col md="3">
                      <Label>Property address</Label>
                    </Col>
                    <Col xs="12" md="9">
                      <Input
                        type="text"
                        name="property_address"
                        value={this.state.formProperty.propertyAddress}
                        placeholder="Property address"
                        valid={this.state.formPropertyError.propertyAddress ? false: null}
                        invalid={this.state.formPropertyError.propertyAddress ? true: null}
                        onChange={(e) => { this.setFormPropertyValue("propertyAddress", e.target.value) }}/>
                      <FormFeedback>{this.state.formPropertyError.propertyAddress}</FormFeedback>
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Col md="3">
                      <Label>City</Label>
                    </Col>
                    <Col xs="12" md="9">
                      <Input
                        type="text"
                        name="city"
                        value={this.state.formProperty.city}
                        placeholder="City"
                        valid={this.state.formPropertyError.city ? false: null}
                        invalid={this.state.formPropertyError.city ? true: null}
                        onChange={(e) => { this.setFormPropertyValue("city", e.target.value) }}/>
                      <FormFeedback>{this.state.formPropertyError.city}</FormFeedback>
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Col md="3">
                      <Label>State</Label>
                    </Col>
                    <Col xs="12" md="9">
                      <Input
                        type="select"
                        name="state"
                        value={this.state.formProperty.state}
                        placeholder="State"
                        valid={this.state.formPropertyError.state ? false: null}
                        invalid={this.state.formPropertyError.state ? true: null}
                        onChange={(e) => { this.onChangeState(e.target.value) }}>
                        <option value="">Please select</option>
                        {USA_STATES.map( (state, index) => {
                          return (
                            <option key={state.key} value={state.key}>{state.name}</option>
                          )
                        } )}
                      </Input>
                      <FormFeedback>{this.state.formPropertyError.state}</FormFeedback>
                    </Col>
                  </FormGroup>
                  {this.renderSurveyTypes()}
                  <FormGroup row>
                    <Col md="3">
                      <Label>Zip code</Label>
                    </Col>
                    <Col xs="12" md="9">
                      <Input
                        type="text"
                        name="zip_code"
                        value={this.state.formProperty.zipCode}
                        placeholder="Zip code"
                        valid={this.state.formPropertyError.zipCode ? false: null}
                        invalid={this.state.formPropertyError.zipCode ? true: null}
                        onChange={(e) => { this.setFormPropertyValue("zipCode", e.target.value) }}/>
                      <FormFeedback>{this.state.formPropertyError.zipCode}</FormFeedback>
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Col md="3">
                      <Label>Phone number</Label>
                    </Col>
                    <Col xs="12" md="9">
                      <Input
                        type="text"
                        name="phone_number"
                        value={this.state.formProperty.phoneNumber}
                        placeholder="Phone number"
                        valid={this.state.formPropertyError.phoneNumber ? false: null}
                        invalid={this.state.formPropertyError.phoneNumber ? true: null}
                        onChange={(e) => { this.setFormPropertyValue("phoneNumber", e.target.value) }}/>
                      <FormFeedback>{this.state.formPropertyError.phoneNumber}</FormFeedback>
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Col md="3">
                      <Label>Fax number</Label>
                    </Col>
                    <Col xs="12" md="9">
                      <Input
                        type="text"
                        name="fax_number"
                        value={this.state.formProperty.faxNumber}
                        placeholder="Fax number"
                        valid={this.state.formPropertyError.faxNumber ? false: null}
                        invalid={this.state.formPropertyError.faxNumber ? true: null}
                        onChange={(e) => { this.setFormPropertyValue("faxNumber", e.target.value) }}/>
                      <FormFeedback>{this.state.formPropertyError.faxNumber}</FormFeedback>
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Col md="3">
                      <Label>Contact name</Label>
                    </Col>
                    <Col xs="12" md="9">
                      <Input
                        type="text"
                        name="contact_name"
                        value={this.state.formProperty.contactName}
                        placeholder="Contact name"
                        valid={this.state.formPropertyError.contactName ? false: null}
                        invalid={this.state.formPropertyError.contactName ? true: null}
                        onChange={(e) => { this.setFormPropertyValue("contactName", e.target.value) }}/>
                      <FormFeedback>{this.state.formPropertyError.contactName}</FormFeedback>
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Col md="3">
                      <Label>Contact title</Label>
                    </Col>
                    <Col xs="12" md="9">
                      <Input
                        type="text"
                        name="contact_title"
                        value={this.state.formProperty.contactTitle}
                        placeholder="Contact title"
                        valid={this.state.formPropertyError.contactTitle ? false: null}
                        invalid={this.state.formPropertyError.contactTitle ? true: null}
                        onChange={(e) => { this.setFormPropertyValue("contactTitle", e.target.value) }}/>
                      <FormFeedback>{this.state.formPropertyError.contactTitle}</FormFeedback>
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Col md="3">
                      <Label>Contact email</Label>
                    </Col>
                    <Col xs="12" md="9">
                      <Input
                        type="text"
                        name="contact_email"
                        value={this.state.formProperty.contactEmail}
                        placeholder="Contact email"
                        valid={this.state.formPropertyError.contactEmail ? false: null}
                        invalid={this.state.formPropertyError.contactEmail ? true: null}
                        onChange={(e) => { this.setFormPropertyValue("contactEmail", e.target.value) }}/>
                      <FormFeedback>{this.state.formPropertyError.contactEmail}</FormFeedback>
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Col md="3">
                      <Label>General Manager</Label>
                    </Col>
                    <Col xs="12" md="9">
                      <Input
                        type="text"
                        name="general_manager_name"
                        value={this.state.formProperty.generalManagerName}
                        placeholder="General Manager"
                        valid={this.state.formPropertyError.generalManagerName ? false: null}
                        invalid={this.state.formPropertyError.generalManagerName ? true: null}
                        onChange={(e) => { this.setFormPropertyValue("generalManagerName", e.target.value) }}/>
                      <FormFeedback>{this.state.formPropertyError.generalManagerName}</FormFeedback>
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Col md="3">
                      <Label>Number of rooms</Label>
                    </Col>
                    <Col xs="12" md="9">
                      <Input
                        type="text"
                        name="number_of_rooms"
                        value={this.state.formProperty.numberOfRooms}
                        placeholder="Number of rooms"
                        valid={this.state.formPropertyError.numberOfRooms ? false: null}
                        invalid={this.state.formPropertyError.numberOfRooms ? true: null}
                        onChange={(e) => { this.setFormPropertyValue("numberOfRooms", e.target.value) }}/>
                      <FormFeedback>{this.state.formPropertyError.numberOfRooms}</FormFeedback>
                    </Col>
                  </FormGroup>

                  {this.renderLuxuryPropertyField()}
                  {this.renderUnionPropertyField()}
                  {this.renderInnPropertyField()}
                  {this.renderGolfPropertyField()}
                  {this.renderLimitedPropertyField()}
                  {this.renderZoneField()}
                </div>
              </Form>
            </CardBody>
            <CardFooter>
              <Button onClick={() => this.updateProperty()} type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> {this.state.isEdit ? 'Save' : 'Create'}</Button>
            </CardFooter>
          </Card>
        </Col>
      );
    }
  }

  onPropertyAlertDismiss() {
    this.setState({
      propertyAlert: {
        message: "",
        color: ""
      }
    });
  }

  onProfileAlertDismiss() {
    this.setState({
      profileAlert: {
        message: "",
        color: ""
      }
    });
  }

  renderProfileForm() {
    if ( this.state.renderProfileForm ) {
      return (
        <Col xs="12" md="6">
          <Row>
              <Col xs="12" md="12">
          <Card>
            <CardHeader>
              <strong>Profile</strong>
            </CardHeader>
            <CardBody>
              <Alert color={this.state.profileAlert.color} isOpen={this.state.profileAlert.message != ""} toggle={() => this.onProfileAlertDismiss()}>
                {this.state.profileAlert.message}
              </Alert>
              <Form>
                <FormGroup row>
                  <Col md="3">
                    <Label>Email</Label>
                  </Col>
                  <Col xs="12" md="9">
                    <p className="form-control-static">{this.state.formProfile.email}</p>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Col md="3">
                    <Label>First name</Label>
                  </Col>
                  <Col xs="12" md="9">
                    <Input
                      type="text"
                      name="firstName"
                      value={this.state.formProfile.firstName}
                      placeholder="First name"
                      valid={this.state.formProfileError.firstName ? false : null}
                      invalid={this.state.formProfileError.firstName ? true : null}
                      onChange={(e) => { this.setFormProfileValue("firstName", e.target.value) }}/>
                    <FormFeedback>{this.state.formProfileError.firstName}</FormFeedback>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Col md="3">
                    <Label>Last name</Label>
                  </Col>
                  <Col xs="12" md="9">
                    <Input
                      type="text"
                      name="lastName"
                      value={this.state.formProfile.lastName}
                      placeholder="Last name"
                      valid={this.state.formProfileError.lastName ? false : null}
                      invalid={this.state.formProfileError.lastName ? true : null}
                      onChange={(e) => { this.setFormProfileValue("lastName", e.target.value) }}/>
                    <FormFeedback>{this.state.formProfileError.lastName}</FormFeedback>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Col md="3">
                  </Col>
                  <Col xs="12" md="9">
                    <FormGroup check>
                      <Label check>
                        <Input
                          type="checkbox"
                          name="join_surveys"
                          value={this.state.formProfile.joinSurveys}
                          checked={this.state.formProfile.joinSurveys}
                          onChange={(e) => { this.setFormProfileValue("joinSurveys", e.target.checked) }}/>
                          I want to participate
                      </Label>
                    </FormGroup>
                  </Col>
                </FormGroup>
                <Row>
                  <Col xs="12" md="12">
                      <h5>
                        RESULTS INFORMATION:<br/>
                        <small>We wish our results to be sent back to us as follows :</small>
                      </h5>
                  </Col>
                </Row>
                <Row>
                  <Col xs="12" md="12">
                    <FormGroup check>
                      <Label check>
                        <Input
                          type="checkbox"
                          name="is_email_result"
                          value={this.state.formProfile.isEmailResult}
                          checked={this.state.formProfile.isEmailResult}
                          onChange={(e) => { this.setFormProfileValue("isEmailResult", e.target.checked) }}/>
                          Via Email (no additional charge)
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col xs="12" md="12">
                    <FormGroup check>
                      <Label check>
                        <Input
                          type="checkbox"
                          name="is_hard_copy_result"
                          value={this.state.formProfile.isHardCopyResult}
                          checked={this.state.formProfile.isHardCopyResult}
                          onChange={(e) => { this.setFormProfileValue("isHardCopyResult", e.target.checked) }}/>
                          Via Hard Copy Manual (additional cost-please inquire)
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>
              </Form>
            </CardBody>
            <CardFooter>
              <Button type="submit" onClick={(e) => { e.preventDefault(); this.updateProfile(); }} size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
            </CardFooter>
          </Card>
          </Col>
        </Row>
        <Row>
          <Col xs="12" md="12">
            {this.renderPropertyList()}
          </Col>
        </Row>
        </Col>
      )
    }
  }

  changePropertiesState() {
    this.setState({ isListUpdated: false });
  }

  renderPropertyList() {
    const props = {
      isListUpdated: this.state.isListUpdated,
      userProfile: this.state.formProfile,
      onEditPropertyClick: this.onEditPropertyClick,
      onCreatePropertyClick: this.onCreatePropertyClick,
      changePropertiesState: this.changePropertiesState
    };

    if ( this.state.renderPropertyForm ) {
      return (
        <PropertyList {...props} />
      )
    }
  }

  render() {
    return (
      <div className="animated fadeIn">
        <Row>
          {this.renderProfileForm()}
          {this.renderPropertyForm()}
        </Row>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
    user: state.user
});

export default connect(mapStateToProps)(Profile);



// WEBPACK FOOTER //
// ./src/views/Account/Profile/Profile.js